export const minutesRenderer = (_instance, td, _row, _col, _prop, value) => {
  if (value == null || !value) {
    td.innerHTML = `<div class="truncated"></div>`;
    return td;
  }

  const totalMinutes = value;
  const days = Math.floor(totalMinutes / (60 * 8));
  const remainingMinutes = totalMinutes % (60 * 8);

  const hours = Math.floor(remainingMinutes / 60);
  const minutes = remainingMinutes % 60;

  let output;

  if (days > 0) {
    output = `${days} day${days > 1 ? "s" : ""}`;
  } else {
    output = `${hours}:${minutes.toString().padStart(2, "0")}`;
  }

  td.innerHTML = `<div class="truncated">${output}</div>`;

  return td;
};
